<div class="modal-window--common-modal" *ngIf="responseResult != null">
  <div class="close-btn" (click)="closeModal()">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <defs>
        <style>.common_modal-close-cls-1{fill:#495660;}.common_modal-close-cls-2{fill:none;}</style>
      </defs>
      <title>Ресурс 15</title>
      <g id="Слой_2" data-name="Слой 2">
        <g id="Слой_8" data-name="Слой 8">
          <rect class="common_modal-close-cls-1" x="4" y="4" width="1" height="1"/>
          <rect class="common_modal-close-cls-1" x="3" y="3" width="1" height="1"/>
          <rect class="common_modal-close-cls-1" x="5" y="5" width="1" height="1"/>
          <rect class="common_modal-close-cls-1" x="6" y="6" width="1" height="1"/>
          <rect class="common_modal-close-cls-1" x="7" y="7" width="1" height="1"/>
          <rect class="common_modal-close-cls-1" x="7" y="7" width="1" height="1"/>
          <rect class="common_modal-close-cls-1" x="8" y="8" width="1" height="1"/>
          <rect class="common_modal-close-cls-1" x="9" y="9" width="1" height="1"/>
          <rect class="common_modal-close-cls-1" x="10" y="10" width="1" height="1"/>
          <rect class="common_modal-close-cls-1" x="11" y="11" width="1" height="1"/>
          <rect class="common_modal-close-cls-1" x="12" y="12" width="1" height="1"/>
          <rect class="common_modal-close-cls-1" x="4" y="11" width="1" height="1" transform="translate(-7 16) rotate(-90)"/>
          <rect class="common_modal-close-cls-1" x="3" y="12" width="1" height="1" transform="translate(-9 16) rotate(-90)"/>
          <rect class="common_modal-close-cls-1" x="5" y="10" width="1" height="1" transform="translate(-5 16) rotate(-90)"/>
          <rect class="common_modal-close-cls-1" x="6" y="9" width="1" height="1" transform="translate(-3 16) rotate(-90)"/>
          <rect class="common_modal-close-cls-1" x="7" y="8" width="1" height="1" transform="translate(-1 16) rotate(-90)"/>
          <rect class="common_modal-close-cls-1" x="7" y="8" width="1" height="1" transform="translate(-1 16) rotate(-90)"/>
          <rect class="common_modal-close-cls-1" x="8" y="7" width="1" height="1" transform="translate(1 16) rotate(-90)"/>
          <rect class="common_modal-close-cls-1" x="9" y="6" width="1" height="1" transform="translate(3 16) rotate(-90)"/>
          <rect class="common_modal-close-cls-1" x="10" y="5" width="1" height="1" transform="translate(5 16) rotate(-90)"/>
          <rect class="common_modal-close-cls-1" x="11" y="4" width="1" height="1" transform="translate(7 16) rotate(-90)"/>
          <rect class="common_modal-close-cls-1" x="12" y="3" width="1" height="1" transform="translate(9 16) rotate(-90)"/>
          <rect class="common_modal-close-cls-2" width="16" height="16"/>
        </g>
      </g>
    </svg>
  </div>
  <div class="student-name">{{responseResult.student.surname}} {{responseResult.student.name}}</div>
  <div class="box-title">
    <span class="box-files">
      <span class="box-header" [class.is_extra_exercise]="responseResult?.box_extra_exercise">Box № </span>
      <span class="box-number">{{responseResult.box.title}}</span>
      <br>
      <span *ngFor="let file of responseResult.box.files; let a=index;" class="box-file-title">
        <span *ngIf="a > 0">, </span>
        {{file.str_title}}
      </span>
    </span>
    <span class="box_extra-exercise" *ngIf="responseResult?.box_extra_exercise">
      <span>Доп. задание:</span>
      <span>{{ responseResult?.box_extra_exercise.title }} 
        <br> {{ responseResult?.box_extra_exercise.description | shorten:30 }}</span>
    </span>
  </div>
  <hr class="box-hr">
  <div class="cards-container">
    <div *ngFor="let card of responseResult.cards_results" class="box-cards" [ngClass]="getCardStyle(responseResult.box.cards_format)">
      <div class="card-header-block">
        <span>№ {{card.card_number}}</span>
        <span class="card-hint"> {{card.hint}}</span>
      </div>
      <div *ngFor="let exercise of card.exercises_results; let i=index">

        <div *ngIf="exercise.exercise_type == calculation" class="exercise-calculation" [ngClass]="getTaskSpacingStyle(i)">
          <span>{{i + 1}})&nbsp;&nbsp;</span>
          <span>
            <ng-katex *ngIf="isKatexFormat(exercise)" class="katex" [equation]="exercise.text"></ng-katex>
            <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)"
                class="katex text katex-p"
                [paragraph]="exercise?.exercise_text | exerciseFormat:'text'">
              </ng-katex-paragraph>
          </span>
          <span>&nbsp;&nbsp;</span>
          <span
            [class.exercise-answer-right]="isAnswerCorrect(exercise)"
            [class.exercise-answer-wrong]="!isAnswerCorrect(exercise)">
            <ng-katex-paragraph 
              class="katex text"
              [paragraph]="exercise.shortAnswer | exerciseFormat:'text'">
            </ng-katex-paragraph>
          </span>
          <span *ngIf="!exercise.correct" class="exercise-answer-right-after-wrong">
            <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span>
              <ng-katex-paragraph 
                class="katex text katex-p"
                [paragraph]="exercise.exercise_correct_answers[0].shortAnswer | exerciseFormat:'text'">
              </ng-katex-paragraph>
            </span>
          </span>
        </div>

        <div *ngIf="exercise.exercise_type == task || exercise.exercise_type == logic" class="exercise-task" [ngClass]="getTaskSpacingStyle(i)">
          <div>
            <span class="exercise-text">{{i + 1}})&nbsp;&nbsp;</span>
            <span>
              <ng-katex *ngIf="isKatexFormat(exercise)" class="katex text katex-p" [equation]="exercise?.exercise_text"></ng-katex>
              <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)" 
                  class="katex text katex-p"
                  [paragraph]="exercise?.exercise_text | exerciseFormat:'text'">
              </ng-katex-paragraph>
            </span>
            <ng-container *ngIf="exercise.answer_by_question && exercise.answer_by_question.length > 0">
              <span class="exercise-text"*ngFor="let question of exercise.answer_by_question">
                <ng-katex *ngIf="isKatexFormat(exercise)" class="katex text katex-p" [equation]="question.text"></ng-katex>
                <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)"
                  class="katex text katex-p"
                  [paragraph]="question.text | exerciseFormat:'text'">
                </ng-katex-paragraph>
              </span>
            </ng-container>
          </div>
          <div class="exercise-task-answer-header">Ответ:
            <ng-container *ngIf="exercise.answer_by_question && exercise.answer_by_question.length > 0">
              <ng-container *ngFor="let question of exercise.answer_by_question; let n=index">
                <span *ngIf="n > 0">,&nbsp;</span>
                <span *ngFor="let studentAnswer of question.student_answers; let p=index"
                      [class.exercise-answer-right]="studentAnswer.shortAnswer == question.answers[p].shortAnswer"
                      [class.exercise-answer-wrong]=" studentAnswer.shortAnswer != question.answers[p].shortAnswer">
                  <span *ngIf="p > 0">,&nbsp;</span>
                  <span>&nbsp;&nbsp;</span>
                  <span>
                    <ng-katex-paragraph 
                      class="katex text katex-p"
                      [paragraph]="studentAnswer.shortAnswer | exerciseFormat:'text'">
                    </ng-katex-paragraph>
                  </span>
                </span>
              </ng-container>
              <span *ngIf="!exercise.correct" class="exercise-answer-right-after-wrong">
                <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                <ng-container *ngFor="let question of exercise.answer_by_question; let n=index">
                  <span *ngIf="n > 0">,&nbsp;</span>
                  <span *ngFor="let answer of question.answers; let k=index">
                    <span *ngIf="k > 0">,&nbsp;</span>
                    <span>
                      <ng-katex-paragraph 
                        class="katex text katex-p"
                        [paragraph]="answer.shortAnswer | exerciseFormat:'text'">
                      </ng-katex-paragraph>
                    </span>
                  </span>
                </ng-container>
              </span>
            </ng-container>
            <ng-container *ngIf="!(exercise.answer_by_question && exercise.answer_by_question.length > 0)">
              <span
                [class.exercise-answer-right]="exercise.shortAnswer == exercise.exercise_correct_answers[0].shortAnswer"
                [class.exercise-answer-wrong]="exercise.shortAnswer != exercise.exercise_correct_answers[0].shortAnswer">
                <ng-katex-paragraph 
                  class="katex text katex-p"
                  [paragraph]="exercise.shortAnswer | exerciseFormat:'text'">
                </ng-katex-paragraph>
              </span>
              <span *ngIf="exercise.correct == false" class="exercise-answer-right-after-wrong">
                <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                <ng-container *ngFor="let rightAnswer of exercise.exercise_correct_answers; let n=index">
                  <span *ngIf="n > 0">,&nbsp;</span>
                  <span>
                    <ng-katex-paragraph 
                      class="katex text katex-p"
                      [paragraph]="rightAnswer.shortAnswer | exerciseFormat:'text'">
                    </ng-katex-paragraph>
                  </span>
                </ng-container>
              </span>
            </ng-container>
          </div>
        </div>

        <div *ngIf="exercise.exercise_type == magic_box" >
          <table class="magic-box">
            <tr *ngFor="let row of getMagicBoxObject(exercise.exercise_text); let magic_row=index">
              <td *ngFor="let elem of row; let magic_elem=index" [ngClass]="getMagicBoxTdStyle(elem,exercise,magic_row,magic_elem)">
                <div *ngIf="elem != null" class="magic-box-cell-task">{{ elem }}</div>
                <div *ngIf="elem == null && compareMagicBoxAnswers(exercise,magic_row,magic_elem)" class="magic-box-cell-right">{{ getMagicBoxCellRight(exercise,magic_row,magic_elem) }}</div>
                <div *ngIf="elem == null && !compareMagicBoxAnswers(exercise,magic_row,magic_elem)"><span class="magic-box-cell-right-above-wrong">{{ getMagicBoxCellRight(exercise,magic_row,magic_elem) }}</span><span class="magic-box-cell-wrong">{{ getMagicBoxCellWrong(exercise,magic_row,magic_elem) }}</span></div>
              </td>
            </tr>
          </table>
        </div>

        <div *ngIf="exercise.exercise_type == sequence" class="exercise-sequence" [ngClass]="getTaskSpacingStyle(i)">
          <span>{{i + 1}})&nbsp;</span>
          <span>
            <ng-katex-paragraph 
              class="katex text katex-p"
              [paragraph]="exercise?.exercise_text | exerciseFormat:'text'">
            </ng-katex-paragraph>
          </span>
          <span>&nbsp;&nbsp;</span>
          <span [ngClass]="isAnswerCorrect(exercise)">
            <ng-katex-paragraph 
              class="katex text katex-p"
              [paragraph]="exercise.shortAnswer | exerciseFormat:'text'">
            </ng-katex-paragraph>
          </span>
          <span *ngIf="exercise.correct==false" class="exercise-answer-right-after-wrong">
              <span>&nbsp;</span>
              <span>
                <ng-katex-paragraph 
                  class="katex text katex-p"
                  [paragraph]="exercise?.exercise_text | exerciseFormat:'text'">
                </ng-katex-paragraph>
              </span>
              <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
              <span>
                <ng-katex-paragraph 
                  class="katex text katex-p"
                  [paragraph]="exercise.exercise_correct_answers[0].shortAnswer | exerciseFormat:'text'">
                </ng-katex-paragraph>
              </span>
            </span>
        </div>

        <div *ngIf="[puzzle_task, puzzle_example].includes(exercise.exercise_type)">
          <app-exercise-puzzle
              [exercise]="exercise" [index]="i" [viewType]="'analytics_modal'">
          </app-exercise-puzzle>
        </div>

      </div>
      <div *ngIf="card.is_correct_extra_exercise_result !== null" class="extra_exercise">
        <span>Доп. задание: </span>
        <span>{{ card.is_correct_extra_exercise_result ? "+" : "-" }}</span>
      </div>
      <div class="money-amount">
        {{getMoneyAmount(card.clear_reward)}}
      </div>
      <div *ngIf="box?.smart_sprints.length > 0" class="smart-sprint">
        Время: <b><font color="#4e77af">{{ convertSecondToMinute(card) }}</font></b>
      </div>
    </div>
  </div>
</div>
<div class="modal-window--common-modal" *ngIf="responseResult == null">
  <div class="preloader">
    <mat-progress-spinner
        class="spinner"
        mode="indeterminate"
        *ngIf="!responseResult">
    </mat-progress-spinner>
  </div>
</div>

